import React from "react"
import { Navigate } from "react-router-dom"
import { auth } from "./auth"

export default function PublicRoute({ children }) {
  if (auth.isAuthenticated()) {
    return <Navigate to="/units" replace />
  }
  return children
}
